import debounce from 'lodash.debounce';
import {
  AddRoomObjectDTO,
  LightType,
  RoomDTO,
  RoomObjectType,
  ThermoAssociatedPump,
  ThermoTypeOfObject,
} from '@/../client-generator/generated-clients/plants';
import { PropType } from 'vue';
import { Vue, Options } from 'vue-class-component';
import { IValidableObjectType } from '@/core/services/naming.service';

@Options({
  name: 'NewRoomObject',
  emits: ['remove-object', 'object-change'],
  props: {
    newRoomObject: {
      required: true,
      type: Object as PropType<AddRoomObjectDTO>,
    },
    mainObjectType: {
      required: true,
      type: Number as PropType<RoomObjectType>,
    },
    plantId: {
      type: Number,
      required: true,
    },
    room: {
      type: Object as PropType<RoomDTO>,
      required: true,
    },
  },
})
export default class NewRoomObject extends Vue {
  room!: RoomDTO;
  plantId!: number;
  mainObjectType!: RoomObjectType;
  RoomObjectType = RoomObjectType;
  newRoomObject!: IValidableObjectType;

  invalidNameReason = '';

  get shutterTypes() {
    return [
      {
        value: true,
        label: this.$t('AppResource.Yes'),
      },
      {
        value: false,
        label: this.$t('AppResource.No'),
      },
    ];
  }
  get lightTypes() {
    return [
      {
        value: LightType.Dimmer,
        label: this.$t('AppResource.Dimmer'),
      },
      {
        value: LightType.OnOff,
        label: this.$t('AppResource.OnOffLight'),
      },
    ];
  }

  get fancoilTypes() {
    return [
      {
        value: ThermoTypeOfObject.Heating,
        label: this.$t('AppResource.Heating'),
      },
      {
        value: ThermoTypeOfObject.Cooling,
        label: this.$t('AppResource.Cooling'),
      },
    ];
  }

  get thermostatTypes() {
    return [
      {
        value: ThermoTypeOfObject.Heating,
        label: this.$t('AppResource.Heating'),
      },
      {
        value: ThermoTypeOfObject.Cooling,
        label: this.$t('AppResource.Cooling'),
      },
      {
        value: ThermoTypeOfObject.HeatingAndCooling,
        label: this.$t('AppResource.HeatingAndCooling'),
      },
    ];
  }
  get thermostatAssociatedPump() {
    return [
      {
        value: ThermoAssociatedPump.Yes,
        label: this.$t('AppResource.Yes'),
      },
      {
        value: ThermoAssociatedPump.No,
        label: this.$t('AppResource.No'),
      },
    ];
  }
  
  get showOtherField() {
    return this.mainObjectType === RoomObjectType.Thermostat;
  }

  handleObjectRemove() {
    this.$emit('remove-object');
  }

  onInputChange(e: any) {
    const newRoomObject = { ...this.newRoomObject };
    newRoomObject.name = e.target.value;
    this.$emit('object-change', newRoomObject);
  }
}
